import { Injectable, inject } from '@angular/core';
import { filter, map, Observable, take, tap } from 'rxjs';
import { ProjectResponseGetById, UpdateProjectRequestPartialPatchV1Patch } from '@nx-customer-apps/api-planning-projects';
import { CountryCode, ProjectType } from '@nx-customer-apps/shared/enums';
import { GlobalStore } from '../../state/global/global.store';
import { ProjectStore } from '../../state/project/project.store';
import { HeatPumpIntermediaryMapper } from './heat-pump-intermediary.mapper';
import { GlobalSpinnerService } from '@nx-customer-apps/components';

@Injectable({
    providedIn: 'root'
})
export class HeatPumpIntermediaryService {
    private mapper = inject(HeatPumpIntermediaryMapper);
    private globalSpinnerService = inject(GlobalSpinnerService);
    private projectStore = inject(ProjectStore);
    private globalStore = inject(GlobalStore);

    public isSubsidyPossible(project: ProjectResponseGetById): boolean {
        return (
            project.countryCode === CountryCode.DE &&
            project.address.countryCode === CountryCode.DE &&
            project.projectType === ProjectType.Renovation
        );
    }

    public saveHeatPumpIntermediary(options: {
        migration?: boolean;
        variantId: string;
    }): Observable<{ project: ProjectResponseGetById; request: UpdateProjectRequestPartialPatchV1Patch }> {
        return this.globalStore.state$.pipe(
            filter(state => Boolean(state.project.selectedProject)),
            map(state => ({
                project: state.project.selectedProject!,
                request: this.mapper.stateToProjectRequest(state)
            })),
            tap(({ project, request }) => {
                this.globalSpinnerService.next({
                    isShown: true,
                    loadingText: 'LOADER.TEXT.UPDATING_PROJECT',
                    loadingSubtext: 'LOADER.SUBTEXT.UPDATING_PROJECT'
                });
                this.projectStore.saveHeatPumpIntermediary({ id: project!.id!, request, variantId: options.variantId });
            }),
            take(1)
        );
    }
}
